module.exports = __webpack_public_path__ + "assets/img/dianji.ba360f74.png";